module.exports = __webpack_public_path__ + "static/media/Rk-Header.e9d777d5.PNG";